module.exports = __webpack_public_path__ + "img/logo.6f379da5.png";